import { isSecureProtocol } from '~/utils/common';

export const cookieService = {
  setCookie(cname: string, cvalue: string, exdays = 7): void {
    const date = new Date();

    date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);

    const expires = `expires=${date.toUTCString()}`;

    document.cookie = `${cname}=${cvalue};${expires};${isSecureProtocol}path=/`;
  },

  getCookie(cname: string) {
    const name = `${cname}=`;

    const decodedCookie = decodeURIComponent(document.cookie);
    const cookiesArray = decodedCookie.split(';');

    for (let i = 0; i < cookiesArray.length; i++) {
      let cookie = cookiesArray[i];
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
      }

      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return '';
  },
  /**
   * @deprecated
   * Use setCookie
   */
  setGroupOfCookies(data) {
    for (const prop in data) {
      cookieService.setCookie(prop, data[prop]);
    }
  },
  deleteCookie(cname: string) {
    document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; ${isSecureProtocol}`;
  },
  getAllCookies() {
    return document.cookie.split(';').map((cookie) => {
      const [name, value] = cookie.split('=');
      return {
        name: name.trim(),
        value: decodeURIComponent(value),
      };
    });
  },
};
export const getIsLoggedIn = () => !!cookieService.getCookie('access');
